import React from 'react';

export function Step2Button(props){
    const description=props.label;

    return(
        <div className={`type type-${props.npsClass}`}>
            <div className={`btn-${props.npsClass}`}>
                <span>{description}</span>
            </div>
            <input type="text" className="ng-pristine ng-valid ng-touched" readOnly value={props.value} />
        </div>
    );
}